import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const AuthRoute = ({ children }) => {
  const { user, loading, needsOnboarding } = useAuth()

  console.log('AuthRoute check:', {
    user: !!user,
    loading,
    needsOnboarding
  })

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  // If user is already authenticated, redirect appropriately
  if (user) {
    if (needsOnboarding) {
      return <Navigate to="/onboarding" replace />
    }
    return <Navigate to="/dashboard" replace />
  }

  // User is not authenticated - show auth page (login/signup)
  return children
}

export default AuthRoute